import { Injectable } from '@angular/core';
import { FormBase, TextBox } from '@mapfre-design-library/src/public_api';
import { Constants } from '@models/constants';

@Injectable({
  providedIn: 'root',
})
export class EditPolicyService {
  getInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'editFirst_name',
        label: 'FIRST_NAME',
        required: true,
        type: 'text',
        validationMessageError: 'VALID_NAME_VALIDATION_MESSAGE',
        userSubscription: 'firstName',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'editMI_name',
        label: 'MIDDLE_INITIAL',
        required: false,
        type: 'text',
        validationMessageError: 'VALID_NAME_VALIDATION_MESSAGE',
        userSubscription: 'middleName',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'editLast_name',
        label: 'LAST_NAME',
        required: true,
        type: 'text',
        validationMessageError: 'VALID_NAME_VALIDATION_MESSAGE',
        userSubscription: 'lastName',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'date',
        key: 'editDob',
        label: 'DOB',
        minLength: 10,
        maxLength: 10,
        required: true,
        type: 'dob',
        validationMessageError: 'VALID_DOB_VALIDATION_MESSAGE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'editPolicyNumber',
        label: 'POLICY_NUMBER',
        required: true,
        type: 'text',
        maxLength: 13,
        minLength: 6,
        validationMessageError: 'VALID_POLICY_VALIDATION_MESSAGE',
        userSubscription: 'policyDetails[0].policynumber.policyNumber',
      }),
    ];
    return inputs;
  }

  getCommercialAcInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'editCompany_name',
        label: 'COMPANY_NAME_LABEL',
        required: true,
        type: 'text',
        validationMessageError: 'VALID_NAME_VALIDATION_MESSAGE',
        userSubscription: 'firstName',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'email',
        key: 'editEmail',
        label: 'EMAIL',
        minLength: 5,
        required: true,
        type: 'email',
        validationMessageError: 'VALID_EMAIL_VALIDATION_MESSAGE',
        userSubscription: 'email',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'editPolicyNumber',
        label: 'POLICY_NUMBER',
        required: true,
        type: 'text',
        maxLength: 13,
        minLength: 6,
        validationMessageError: 'VALID_POLICY_VALIDATION_MESSAGE',
        userSubscription: 'policyDetails[0].policynumber.policyNumber',
      }),
    ];
    return inputs;
  }
}
